import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=36598f8a&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=36598f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36598f8a",
  null
  
)

export default component.exports